<longmoon-star
  *ngFor="let star of contellationLeo"
  [color]="white"
  [period]="0"
  [size]="star.size"
  [xPos]="star.x"
  [yPos]="star.y"></longmoon-star>
